<script>
	import {docs} from "./store.js";
	let url = "https://vps-1858514-x.dattaweb.com/arteflordepiel";
	let url2 = "http://200.58.99.151:5984/arteflordepiel"
	let rep;
	export async function conectar(){
		rep = PouchDB.sync("db",url,{
			auth:{
				username: "arte",
				password: "flor"
			},
			live: true,
			retry: true
		})
			.on("change",async function (info){
				console.log(info);
				await actualizarDocs();
			})
			.on("error",function(err){
				console.log("replication error:", err)
			})
	}
	export async function actualizarDocs(){
		const allDocs = await db.allDocs({
			include_docs: true
		})
		$docs = allDocs.rows.map(row => row.doc);
	}
	export async function agregarDeposito(doc){
		let newDoc = doc;
		newDoc._id = `deposito:${doc.nombre}`;
		const add = await db.post(newDoc);
		if (add.ok){
			await actualizarDocs();
		}
	}
	export async function editarDeposito(old,doc){
		let newDoc = doc;
		newDoc._rev = old._rev;
		newDoc._id = old._id;
		const upd = await db.put(newDoc);
		if (upd.ok){
			await actualizarDocs();
		}
	}	
	export async function eliminarDeposito(doc){
		const remove = await db.remove(doc);
		if (remove.ok){
			$docs = $docs.filter((el)=>el._id !== doc._id);
		}
	}
	export async function cargarStock(lista){
		db.bulkDocs(lista).then(async (res)=>{
			await actualizarDocs();
		}).catch((err)=>{
			console.log(err);
		})
	}
	export async function agregarEmpleado(doc){
		let newDoc = doc;
		let f = Date.now();
		newDoc.fecha = f;
		newDoc._id = `empleado:${doc.sobrenombre}-${doc.nombre}-${doc.apellido}`;
		const add = await db.post(newDoc);
		if (add.ok){
			await actualizarDocs();
		}
	}
	export async function editarEmpleado(old,doc){
		let newDoc = doc;
		newDoc._rev = old._rev;
		newDoc._id = old._id;
		const upd = await db.put(newDoc);
		if (upd.ok){
			await actualizarDocs();
		}
	}	
	export async function eliminarEmpleado(doc) {
		const remove = await db.remove(doc);
		if (remove.ok){
			$docs = $docs.filter((el)=>el._id !== doc._id);
		}
	}

	export async function editarCategorias(doc){
		let newDoc = doc;
		if (!doc._id){
			newDoc._id = "config:categorias";
		}
		console.log(newDoc);
		const upd = await db.put(newDoc);
		if (upd.ok){
			await actualizarDocs();
		}
	}
</script>
